import Vue from 'vue'
import Swal from 'sweetalert2'

Vue.mixin({
    methods: {

        // 回傳swal，自行操作swal
        swal() {
            return Swal
        },

        // 資料處理中
        swalProccess(title, click = false) {
            return Swal.fire({
                title: title,
                allowOutsideClick: click,
                onBeforeOpen: () => {
                    Swal.showLoading()
                }
            })
        },

        // 關閉swal, ps.會關掉所有的swal，若要連續顯示，請逐一關閉 & 顯示
        swalClose() {
            return Swal.close()
        },

        // 自動關訊息
        swalMsg(title, msg, icon, action) {
            return Swal.fire({
                title: title,
                icon: icon,
                text: msg,
                onClose: () => {
                    action
                }
            })
        },

        // 右上角小彈跳視窗
        toast(title, icon) {
            return Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            }).fire({
                icon: icon,
                title: title
            })
        },

        // 預設錯誤訊息
        swalError(msg = "", action) {
            let eMsg = "請稍後再試或者聯繫客服人員"
            let errorMsg = msg != "" ? eMsg + "，錯誤訊息：" + msg : eMsg
            return Swal.fire({
                title: "錯誤",
                icon: "error",
                timer: 5000,
                text: errorMsg,
                timerProgressBar: true,
                onClose: () => {
                    action
                }
            })
        }

    }
})